<template>
  <sModal
    v-if="!$acl.get.includes('tenders_view')"
    v-model="dialog"
    data-qa="supplier-inspection-decision"
    :title="onlyFiles ? $t('Tenders.ToAddDocs') : $t('Suppliers.SupplierInspectionDecision')"
    @close="close">
    <sForm
      ref="form"
      :disabled="loading"
      :model="formData"
      :rules="rules">
      <sFormItem
        v-if="!onlyFiles"
        prop="recommend">
        <RadioGroup
          class-name="mt-0 mb-4 py-0"
          data-qa="recommend"
          :items="[{value: 'RECOMENDED', label: $t('Suppliers.RecommendedFCooperation') },
                   {value: 'NOT_RECOMENDED', label: $t('Suppliers.NotRecommendedFCooperation')}]"
          :model.sync="formData.recommend"/>
      </sFormItem>
      <sFormItem
        v-if="!onlyFiles"
        :label="$t('Common.YourComment')"
        prop="comment">
        <sInput
          clearable
          :max-length="254"
          max-rows="7"
          :placeholder="$t('Common.OptionalComment')"
          rows="3"
          show-word-limit
          trim
          type="textarea"
          :value.sync="formData.comment"/>
      </sFormItem>
      <sFormItem
        v-if="useData && !onlyFiles"
        :label="$t('StopLists.RelevanceStatus')"
        prop="period">
        <div class="flex flex-between width-100">
          <DateMenu
            ref="menu_actual_date"
            :disabled="loading"
            :min_date="currentDate"
            :value.sync="formData.period"
            with_allowed_dates
            @click.stop/>
          <sAlert
            style="width: 324px">
            <template slot="desc">
              {{ $t('Suppliers.RelevanceStatusToIs') }}
            </template>
          </sAlert>
        </div>
      </sFormItem>
      <sFormItem
        v-if="!tenderId"
        :label="$t('Tenders.ToAddDocs')"
        prop="documents">
        <ImportBlock
          :add-files="addFiles"
          class="mt-5"
          :create-file-handler="createFileHandler"
          data-qa="files"
          :disabled="!!loading"
          :files.sync="files"
          files-types
          inline-style="width: 100%"
          :new-endpoints="true"
          :preview="false"
          @deleteFile="deleteFile"/>
      </sFormItem>
    </sForm>
    <div
      key="footer"
      slot="footer">
      <template
        v-if="!onlyFiles">
        <sButton
          data-qa="btn-apply"
          :disabled="loading"
          @click="apply">
          {{ $t('Common.Save') }}
        </sButton>
        <sButton
          class="ml-6"
          data-qa="btn-exit"
          :disabled="loading"
          type="text"
          @click="close">
          {{ $t('Common.Cancel') }}
        </sButton>
      </template>
      <template
        v-else>
        <sButton
          data-qa="btn-exit"
          :disabled="loading"
          type="text"
          @click="close">
          {{ $t('Common.Close') }}
        </sButton>
      </template>
    </div>
  </sModal>
</template>
<script>
import RadioGroup from 'components/common/inputs/RadioGroup.vue'
import DateMenu from 'components/common/inputs/DateMenu.vue'
import ImportBlock from 'components/common/blocks/ImportBlock.vue'

import SuppliersApi from '@/api/suppliersApi'
const api = new SuppliersApi()
import { debounce } from 'toolkit/utils/util'
import { StorageFile } from '@/types/commonFile.js'

import textFunctions from 'mixins/textFunctions'

export default {
  name: 'SupplierInspectionDecisionModal',
  mixins: [ textFunctions ],
  data() {
    const that = this
    return {
      loading: false,
      currentDate: null,
      defaultDate: null,
      files: [],
      formData: {
        recommend: 'RECOMENDED',
        comment: '',
        period: null,
      },
      rules: {
        comment: {
          type: 'string',
          trigger: 'change',
          validator: (rule, value, callback) => {
            if (that.formData.comment?.length > 254) {
              callback(new Error(
                `${this.$t('Validate.maxLength', {number: 4000, type: this.$tс('Common.characters', 10) })}`
              ))
            }
            callback()
          },
        }
      }
    }
  },
  methods: {
    deleteFile(props) {
      this.$emit('deleteFile', props)
    },
    addFiles(files) {
      //this.$emit('blockSteps', true)
      this.uploadFiles(files)//.finally(() =>  this.$emit('blockSteps', false))
    },
    async uploadFiles(files) {
      let promises = files.filter(file => !file.id).map(async (file,) => {
        return await file.uploadFile()
          .then(res => {
            if (res) {
              file.key = res
              file.fileId = res
              file.uri = `${window.config.GrapgQlUrl}/document/${res}`
              this.$emit('addedNewFile', file)
            } else {
              file.error = true
            }
          })
          .catch(er => {
            this.files = this.files.slice(0)
            file.catchUploading(er)
          })
      })
      await Promise.allSettled(promises)
    },
    createFileHandler(file) {
      file.title = file.name
      file.dateModified = new Date()
      return new StorageFile(this.supplier.supplierOrganizationId, file, 'Crm')
    },
    apply: debounce(async function () {
      this.$refs.form.validate()
        .then(async (valid) => {
          if (!valid) {
            this.loading = false
            return
          }
          this.loading = true

          let statusActualTo
          if (this.formData.period) {
            const newDate = new Date(this.formData.period)
            newDate.setHours(23, 59, 59, 999)
            statusActualTo = this.$_getDateCSharp(newDate)
          }

          const model = {
            supplierOrganizationId: this.supplier.supplierOrganizationId ?? this.supplier.bidderInfo.organizationId,
            statusActualTo,
            verificationStatus: 'VERIFIED',
            comment: this.formData.comment,
            decisionType: this.formData.recommend,
          }

          await api.createOrUpdateSupplierVerification(model, this.tenderId)
            .then(res => {
              if (res) {
                this.$emit('updateItem')
                this.$root.$emit('updateSupplierVerification', { tenderId: this.tenderId, model })
                this.close()
              }
            })
            .finally(() => {
              this.loading = false
            })
        })
    }, 250),
    close() {
      this.dialog = false
      this.files = []
      this.$notice.closeAll()
      this.$emit('close')
    },
  },
  computed: {
    dialog: {
      get() {
        return this.show
      },
      set(value) {
        this.$emit('update:show', value)
      }
    }
  },
  components: {
    DateMenu,
    RadioGroup,
    ImportBlock,
  },
  watch: {
    show: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.$refs.formData?.clearValidate()
          if (this.useData) {
            this.formData.period = this.supplier?.statusActualTo ? new Date(this.supplier?.statusActualTo).toISOString().split('T')[0] : this.defaultDate
          }
          this.formData.comment = this.supplier?.verification?.comment ?? this.supplier?.revisionComment ?? ''
          this.formData.recommend = this.supplier?.verification?.decisionType ?? this.supplier?.decisionType ?? 'RECOMENDED'
        }
      }
    }
  },
  created() {
    this.currentDate = new Date().toISOString().split('T')[0]

    const newDate = new Date()
    newDate.setMonth(newDate.getMonth() + 6)
    this.defaultDate = newDate.toISOString().split('T')[0]
  },
  props: {
    supplier: Object,
    show: Boolean,
    tenderId: Number, // передается если это решение принимает СБ (вызов с детальной тендера)
    useData: {
      type: Boolean,
      default: true
    },
    onlyFiles: Boolean
  },
}
</script>
